var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { positionClass, text, title, identifier, isCloseBtn } = options; 
__p+='\n<div class="feature-notice '+
((__t=( positionClass ))==null?'':__t)+
'" id="'+
((__t=( identifier ))==null?'':__t)+
'" style="display:none;">\n  <div class="feature-notice-arrow"></div>\n  <div class="feature-notice-content">\n    <div class=\'title\'>'+
((__t=( title ))==null?'':__t)+
'</div>\n    <div class=\'text\'>'+
((__t=( text ))==null?'':__t)+
'</div>\n    ';
 if (isCloseBtn){ 
__p+='\n      <div class="js-feature-notice-close feature-notice-close"><i class="ra ra-close-thin"></i></div>\n    ';
 } 
__p+='\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/feature_notice.jst.ejs